import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { EntFeed } from 'src/app/models/commission/ent-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { CommissionService } from 'src/app/service/commission.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-edit-entfeed',
  templateUrl: './edit-entfeed.component.html',
  styleUrls: ['./edit-entfeed.component.css']
})
export class EditEntfeedComponent implements OnInit {
  public entFeedModel = new EntFeed();
  public header: string = 'Edit Feed Data';
  public IsmodelShow: boolean = false;
  public controlStr = new FormControl();

  public actions: any;
  public actionButtons: any;
  public buttons: Buttons[] = [];
  public field: string;
  public ordersTableColumns: TableColumn[];
  public columnsData: any;
  public isStatus: string = "";
  public resHeadder: string = 'ENT Feed Results';
  public check: boolean = true;
  public flags: string[] = ['Y', 'N'];

  public translateMasterdata: EntFeed[] = [];
  public isEntReleaseMode: boolean = false;

  private normalizeStatus(v: any): string {
    return (v ?? '').toString().trim().toLowerCase();
  }

  // Paid / Cancel => lock the screen (no edits)
  get isLockedStatus(): boolean {
    const s = this.normalizeStatus(this.entFeedModel?.status);
    return s === 'paid' || s === 'cancel' || s === 'cancelled';
  }

  // Revenue editable only when NOT locked
  get canEditRevenue(): boolean {
    return !this.isLockedStatus;
  }


  constructor(private komFeedService: KomFeedService, private commissionService: CommissionService,
    private notificationService: NotificationService, private router: Router, private httpService: HttpClient) { }

  ngOnInit(): void {
    this.entFeedModel = this.commissionService.editEntFeedModel;
    this.isStatus = (this.commissionService.editEntFeedModel as any).actionStatus || this.commissionService.editEntFeedModel.status;

this.isEntReleaseMode = !!this.commissionService.entFeedModel?.isEntRelease;

if (this.isStatus === "Update") {
  this.header = this.isEntReleaseMode ? 'Edit Enterprise Release Data' : 'Edit Ent Feed Data';
} else if (this.isStatus === "Replicate") {
  this.header = this.isEntReleaseMode ? 'Replicate Enterprise Release Data' : 'Replicate Feed Data';
}

  }

 

  public back() {
    this.router.navigate(['/ent-feed-results']);
  }

  public save(comboForm: NgForm) {
    this.update();

  }

  public update() {

    // ✅ BLOCK update when status is Paid/Cancel
    if (this.isLockedStatus) {
      this.notificationService.sendNotification(
        NotificationType.ERROR,
        'This record is Paid/Cancelled and cannot be edited.'
      );
      return;
    }
  
    this.entFeedModel.last_modified_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.entFeedModel.last_modified_on = new Date();
  
    const req$ = this.isEntReleaseMode
      ? this.komFeedService.updateEntReleaseByID(this.entFeedModel)
      : this.komFeedService.updateEntFeedByID(this.entFeedModel);
  
    req$.subscribe(
      (response: CustomHttpRespone) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
      },
      (error: HttpErrorResponse) => {
        const msg = error?.error?.message || error?.message || 'Server Error';
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }
  
  

  Replicate() {
    console.log("Replicate Called");
    this.entFeedModel.id = this.entFeedModel.id;
    console.log(this.entFeedModel.id);
    this.entFeedModel.id = 0;
    this.entFeedModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.entFeedModel.created_dt = new Date();
    console.log(this.entFeedModel);
    this.komFeedService.addNewEntAdjustment(this.entFeedModel).subscribe(
      (response: CustomHttpRespone) => {
        //console.log(response);
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully");
        this.router.navigate(['/' + 'ent-feed-results']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }



 




  redirect() {
    this.router.navigate(['/adjustments-feed']);
  }

 
  close(kpiForm: NgForm, id: string) {
   
    kpiForm.reset();
    document.getElementById(id).click();
  }

}
